import React from 'react';

export default function Blog001() {
  return (
    <section>
        <article>
          <h2>1. 08-06-2022</h2>
          <h3>Starting the Blog</h3>
          <p>
            "I envy people who do a little of this, a little of that" -
            Idiocracy
          </p>
          <p>
            I am currently coding this page. I considered using a blogging
            platform, but saw this as a coding exercise opportunity. <br />
            I am currently on my fifth week of Coding. I am starting with HTML,
            CSS, and JavaScript. I have a plethora of learning sources
            including:
          </p>
          <ul>
            <li>freeCodeCamp</li>
            <li>odinProject</li>
            <li>warriorjs</li>
            <li>codeWars</li>
            <li>hackerRank</li>
          </ul>
          I am reading a few books as well.
          <ul>
            <li>Learn to Code. Get a job. - Gwendolyn Faraday</li>
            <li>Beginners Step-by-Step Coding Course - Darling Kindersley</li>
            <li>The Gamers guide to Coding - Gordon McComb</li>
            <li>
              Learning Coding Basics in Hours with Javascript - Tech Academy
            </li>
            <li>
              Get Coding! Learn HTML, CSS, and Javscript and build a website,
              app, and game <br />
              - Young Rewired State
            </li>
          </ul>
          <p>
            I have my learning sources, I have a criteria plan, and a curriculum
            set. <br />
            Though this will probably evolve over time, my current curriculum
            is:
          </p>
          <ul>
            <li>HTML</li>
            <li>CSS</li>
            <li>Javascript</li>
            <li>Git</li>
            <li>React.JS</li>
            <li>Typescript</li>
            <li>Java</li>
            <li>Kotlin</li>
            <li>SQL</li>
            <li>Python</li>
          </ul>
          <p>
            If you know the industry, you probably know what I am going with
            that list. <br />
            My short-term goal current focus is be Web Development. As I dive
            deeper into the subject I will develope web apps and apps. With a
            few reputable projects, using each language, I will continue to
            learning Java and start with back-end development. <br />
            From here I would like to extend my knowledge of mobile engineering
            and start learning Kotlin. With a few projects I will continue
            forward <br />
            The next step is enforcing and gaining skills for back-end
            development. With that I will learn SQL, and then Python. <br />
            This leads me to my long-term end-goal of becoming a Full-Stack
            developer and UX/UI Mobile Developer
          </p>
        </article>
        <h4>Links</h4>
        <br />
        <ul>
          <li>
            <a
              href="https://ericpolley.github.io/Projects_landing_page/"
              title="My first 5 weeks of Coding"
              ><p><strong>My first 5 weeks of Coding Projects</strong></p></a
            >
          </li>
        </ul>
      </section>
   
  )
}
